import { Helmet } from "react-helmet";
import { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

const PHONE = "021-86198022";
const PHONEEN = "info@aramisautomation.com";
const EMAIL = "info@aramisautomation.com";
const EMAILEN = "info@ltn-industrial.com";
const N8N_WEBHOOK_URL =
  "https://n8n-on-render-pl4t.onrender.com/webhook/contact"; // آدرس n8n

const N8N_WEBHOOK_URLEN =
  "https://n8n-on-render-pl4t.onrender.com/webhook/contact"; // آدرس n8n

export default function ContactUs() {
  const { t } = useTranslation();
  const { lang: langParam } = useParams();
  const location = useLocation();
  const seg = location.pathname.split("/")[1];
  const lang = langParam || (seg === "fa" || seg === "en" ? seg : "en");

  const [form, setForm] = useState({
    firstName: "",
    lastName: "",
    phone: "",
    target: "person1",
    note: "",
  });
  const [loading, setLoading] = useState(false);
  const [msg, setMsg] = useState(null);

  const phoneCurrent = lang === "en" ? PHONEEN : PHONE;

  const emailCurrent = lang === "en" ? EMAILEN : EMAIL;
  const n8nUrl = lang === "en" ? N8N_WEBHOOK_URLEN : N8N_WEBHOOK_URL;
  const ENMAP = (<iframe
    title="map-iframe-en"
    src="https://neshan.org/maps/iframe/places/b3cbdc8ba0a986d2fbe36fb9063c5dbe#c35.761-51.415-19z-0p/35.760756900000004/51.4152099"
    width="100%"
    height="250"
    style={{ border: 0 }}
    allowFullScreen
    loading="lazy"
    referrerPolicy="no-referrer-when-downgrade">
  </iframe>)
  const FAMAP = (<iframe
    title="map-iframe"
    src="https://neshan.org/maps/iframe/places/b3cbdc8ba0a986d2fbe36fb9063c5dbe#c35.761-51.415-19z-0p/35.760756900000004/51.4152099"
    width="100%"
    height="250"
    allowFullScreen
    loading="lazy"
  />)
  const MAP = lang === "en" ? ENMAP : FAMAP
  // انیمیشن ورودی
  useEffect(() => {
    const targets = document.querySelectorAll(".fade-in");
    if (!("IntersectionObserver" in window)) {
      targets.forEach((el) => el.classList.add("visible"));
      return;
    }
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("visible");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1 }
    );
    targets.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  const handleAddressClick = () => {
    const address = t("contact.address");
    const enc = encodeURIComponent(address);
    const url =
      lang === "en"
        ? `https://www.google.com/maps/search/?api=1&query=${enc}`
        : `https://neshan.org/maps/route?destination=${enc}`;
    window.open(url, "_blank");
  };

  const handlePhoneClick = (ext) => {
    const phoneNumber = ext ? `${phoneCurrent},${ext}` : phoneCurrent;
    window.location.href = `tel:${phoneNumber}`;
  };

  // جایگزین handleEmailClick
  const handleEmailClick = () => {
    window.location.href = `mailto:${emailCurrent}`;
  };

  // تغییر فرم
  const onChange = (e) => {
    setForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  // ارسال فرم
  const onSubmit = async (e) => {
    e.preventDefault();
    setMsg(null);

    if (!form.firstName.trim() || !form.phone.trim()) {
      setMsg({
        type: "err",
        text:
          lang === "en"
            ? "Name & phone required"
            : "نام و شماره تماس الزامی است",
      });
      return;
    }
    if (form.note.length > 50) {
      setMsg({
        type: "err",
        text:
          lang === "en"
            ? "Note must be ≤ 50 chars"
            : "توضیحات باید حداکثر ۵۰ کاراکتر باشد",
      });
      return;
    }

    setLoading(true);






    try {
      const res = await fetch(n8nUrl, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          firstName: form.firstName.trim(),
          lastName: form.lastName.trim(),
          phone: form.phone.trim(),
          target: form.target,
          note: form.note.trim().slice(0, 50),
          userAgent: navigator.userAgent,
          ts: new Date().toISOString(),
        }),
      });
      if (!res.ok) throw new Error("Network error");
      setMsg({
        type: "ok",
        text: lang === "en" ? "Sent successfully" : "پیام با موفقیت ارسال شد",
      });
      setForm({
        firstName: "",
        lastName: "",
        phone: "",
        target: "person1",
        note: "",
      });
    } catch (err) {
      setMsg({
        type: "err",
        text: lang === "en" ? "Send failed" : "ارسال ناموفق بود",
      });
    }
    setLoading(false);
  };

  return (
    <>
      <Helmet>
        <title>{t("contact.seo.title")}</title>
        <meta name="description" content={t("contact.seo.description")} />
      </Helmet>

      <div className="container" dir={lang === "en" ? "ltr" : "rtl"}>
        <div className="contactus">
          <h1 className="text-blue1 mt-5 mb-5 fs-6">{t("contact.title")}</h1>

          <div className="row">
            {/* ستون ۱: نقشه */}
            <div className="col-xs-12 col-md-4 mb-3 fade-in from-right delay-1">
              {MAP}

            </div>

            {/* ستون ۲: اطلاعات تماس */}
            <div className="col-xs-12 col-md-8">
              <ul>
                <li onClick={() => handlePhoneClick()} style={{ cursor: "pointer" }}>
                  <img src="/assets/phoneblue.png" alt={t("contact.phoneLabel")} /> {phoneCurrent}
                </li>
                <li onClick={handleEmailClick} style={{ cursor: "pointer" }}>
                  <img src="/assets/messageblue.png" alt="Email" /> {emailCurrent}
                </li>
                <li>
                  <img
                    src="/assets/clock.png"
                    alt={t("contact.workingHoursAlt")}
                  />{" "}
                  {t("contact.workingHours")}
                </li>
                <li onClick={handleAddressClick} style={{ cursor: "pointer" }}>
                  <img
                    src="/assets/locationblue.png"
                    alt={t("contact.locationLabel")}
                  />{" "}
                  {t("contact.address")}
                </li>
              </ul>
            </div>
          </div>

          {/* فرم تماس */}
          <form onSubmit={onSubmit} className="mt-5 mb-5 form_css">
            <div className="row g-3">
              <h2>{lang === "en" ? "Consultation request form" : "فرم درخواست مشاوره"}</h2>
              <div className="col-md-6">
                <input
                  type="text"
                  name="firstName"
                  className="form-control"
                  placeholder={lang === "en" ? "First Name" : "نام"}
                  value={form.firstName}
                  onChange={onChange}
                  required
                />
              </div>
              <div className="col-md-6 ">
                <input
                  type="text"
                  name="lastName"
                  className="form-control"
                  placeholder={lang === "en" ? "Last Name" : "نام خانوادگی"}
                  value={form.lastName}
                  onChange={onChange}
                />
              </div>
              <div className="col-md-6">
                <input
                  type="tel"
                  name="phone"
                  className="form-control"
                  placeholder={lang === "en" ? "Phone" : "شماره تماس"}
                  value={form.phone}
                  onChange={onChange}
                  required
                />
              </div>
              <div className="col-md-6">
                <select
                  name="target"
                  className="form-control"
                  value={form.target}
                  onChange={onChange}
                >
                  <option value="person1">
                    {lang === "en" ? "R&D" : " معاونت تحقیق و توسعه"}
                  </option>
                  <option value="person2">
                    {lang === "en"
                      ? "Engineering & Execution"
                      : "معاونت مهندسی و اجرایی"}
                  </option>
                </select>
              </div>
              {/* توضیحات */}
              <div className="col-md-12">
                <textarea
                  name="note"
                  value={form.note}
                  onChange={onChange}
                  className="form-control"
                  maxLength={50}
                  rows={4}
                  placeholder={
                    lang === "en"
                      ? "Notes (optional, up to 50 chars)"
                      : "توضیحات (اختیاری، تا ۵۰ کاراکتر)"
                  }
                />
                <div className="form-text" dir="ltr">
                  {form.note.length}/50
                </div>
              </div>
              <div className="col-12">
                <button
                  type="submit"
                  className="btn btn-primary contact_btn_css"
                  disabled={loading}
                >
                  {loading
                    ? lang === "en"
                      ? "Sending..."
                      : "در حال ارسال..."
                    : lang === "en"
                      ? "Send"
                      : "ارسال"}
                </button>
              </div>
              {msg && (
                <div
                  className={`alert mt-3 ${msg.type === "ok" ? "alert-success" : "alert-danger"
                    }`}
                >
                  {msg.text}
                </div>
              )}
            </div>
          </form>
        </div>
      </div>
    </>
  );
}
